import { Routes } from '@angular/router';
import { ChatComponent } from './chat.component';
import { ChatWidgetComponent } from './chat-widget.component';

export const routes: Routes = [
  { path: '', component: ChatWidgetComponent },
  { path: 'embed', component: ChatWidgetComponent },
  { path: 'chat', component: ChatComponent },
];
